// extracted by mini-css-extract-plugin
export default {"form":"HistoryForm_form__IzLLg","button":"HistoryForm_button__eUMp4","formGroup":"HistoryForm_formGroup__BN+pf","editor":"HistoryForm_editor__RNtT3"};